<template>
    <AppJumbotron>
        <div class="flex items-center">
            <div class="flex-grow max-w-screen-md">
                <h1 class="text-white text-3xl md:text-5xl font-bold mb-8">
                    Genuine reviews to help you find the best tyres for your car
                </h1>

                <template v-if="route().has('search')">
                    <p class="text-white mb-4">Find reviews for tyres that match your car</p>

                    <div class="md:max-w-xs">
                        <AppSearchBar v-model="localSearch"
                                      @search="$inertia.get(route('search'), {q: localSearch})"
                                      placeholder="Find a tyre..."></AppSearchBar>
                    </div>
                </template>
            </div>
        </div>
    </AppJumbotron>

    <AppContainer>
        <div class="my-4" v-if="brands && brands.length">
            <h3 class="text-2xl text-dark my-8">
                Tyre Manufacturers
            </h3>

            <div class="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-6 mt-8">
                <BrandImage
                    v-for="brand of brands"
                    :brand="brand"
                ></BrandImage>
            </div>
        </div>

        <div class="my-4" v-if="products && products.length">
            <h3 class="text-2xl text-dark my-8">
                Tyres
            </h3>

            <div class="grid grid-cols-3 md:grid-cols-4 xl:grid-cols-6 gap-8">
                <TyreCard v-for="product of products" :product="product"></TyreCard>
            </div>
        </div>

        <div class="my-4" v-if="manufacturers && manufacturers.length">
            <h3 class="text-2xl text-dark my-8">
                Vehicle Manufacturers
            </h3>

            <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8">
                <ManufacturerCard v-for="manufacturer of manufacturers" :manufacturer="manufacturer"></ManufacturerCard>
            </div>
        </div>

        <div class="my-4" v-if="models && models.length">
            <h3 class="text-2xl text-dark my-8">
                Vehicle Models
            </h3>

            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-8">
                <ModelCard v-for="model of models" :model="model"></ModelCard>
            </div>
        </div>

        <p v-if="!hasResults" class="my-16 text-center">
            We could not find any results for: {{ search }}
        </p>
    </AppContainer>
</template>

<script setup>
import AppHead from "@/Components/AppSeoTags";
import TyreCard from "@/Components/Products/Tyres/TyreCard";
import AppContainer from "@/Layouts/AppContainer";
import ManufacturerCard from "@/Components/Manufacturers/ManufacturerCard";
import ModelCard from "@/Components/Models/ModelCard";
import BrandImage from "@/Components/Brands/BrandImage";
import AppSearchBar from "@/Components/AppSearchBar";
import AppJumbotron from "@/Components/AppJumbotron";
import {computed, ref} from "vue";

const props = defineProps({
    brands: Array,
    products: Array,
    manufacturers: Array,
    models: Array,
    search: String
});

const hasResults = computed(() => {
    const resources = ["brands", "products", "manufacturers", "models"];

    return resources.some(resource => {
        return props[resource] && props[resource].length > 0;
    });
});

const localSearch = ref(props.search);
</script>

<style scoped>

</style>
